import React from "react";
import CarouselItem from "./CarouselItem";

const Carousel = ({
    id,
    groups,
    mode
}: {
    id: string;
    groups: any[][];
    mode: string;
}) => {
    return (
        <div id={id} className="carousel slide d-none d-lg-block" data-ride="carousel">
            <ol className="carousel-indicators">
                {groups.map((_, i) => (
                    <li
                        key={i}
                        data-target={`#${id}`}
                        data-slide-to={i}
                        className={i === 0 ? "active" : ""}
                    ></li>
                ))}
            </ol>
            <div className="carousel-inner">
                {groups.map((group, i) => (
                    <div className={`carousel-item ${i === 0 ? "active" : ""}`} key={i}>
                        <CarouselItem items={group} mode={mode} />
                    </div>
                ))}
            </div>
            <div className="button-placement d-none d-lg-block">
                <a className="btn btn-slide btn-slide-left" href={`#${id}`} role="button" data-slide="prev">
                    <img src="/assets/images/other/caret-left-blue.svg" className="img img-fluid" />
                </a>
                <a className="btn btn-slide btn-slide-right" href={`#${id}`} role="button" data-slide="next">
                    <img src="/assets/images/other/caret-right-blue.svg" className="img img-fluid" />
                </a>
            </div>
        </div>
    );
};

export default Carousel;
